module.exports = __webpack_public_path__ + "img/logo-full.aae94cc9.svg";